import React, {useState} from 'react';

import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import { useHistory, useLocation } from "react-router-dom";

export default (props) => {
  const history = useHistory();
  const location = useLocation();
  const [activeHref, setActiveHref] = useState(`${location.pathname}${location.search}` || props.activeHref);

  const items = [
    { type: "link", text: "Admin panel", href: "/Admin" },
    {
      "type": "link",
      "text": "All Audit Logs",
      "href": "/AllAuditLogs",
      "external": true,
      "target":"_blank"
    },
    { type: "link", text: "Upload App from JSON", href: "?upload=true" },
    { type: "link", text: "Cruzer Admin Panel", href: "/AllCruzerSchedules" },
    { type: "link", text: "Metrics", href: "/Admin?tab=metrics" },
    { type: "link", text: "AI Repo Control Panel", href: "/Admin?tab=ai-repo-control-panel" },
    { type: "link", text: "RAISE Admin Panel", href: "/Admin?tab=raise-admin-panel" },
    { type: "divider" },

    ];
  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ href: "/Admin", text: "Admin panel" }}
      onFollow={e => {
        if (!e.detail.external) {
        e.stopPropagation();
        e.preventDefault();
        history.push(e.detail.href);
        setActiveHref(e.detail.href)
      }
    }}
      items={items}
    />
  );
}